import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './syncToLabConfirmationModal.scss';

export interface ISyncToLabConfirmationModalProps {
    isModalOpen: boolean;
    closeModal: () => void;
    onSyncToLabClick: () => void;
}

export class SyncToLabConfirmationModal extends
    React.Component<ISyncToLabConfirmationModalProps> {
    constructor(props: ISyncToLabConfirmationModalProps) {
        super(props);
        this._closeOpenCycleModal = this._closeOpenCycleModal.bind(this);
        this._syncToLabClick = this._syncToLabClick.bind(this);
        this._cancelOpenCycleModal = this._cancelOpenCycleModal.bind(this);
    }

    render(): React.ReactNode {
        if (!this.props.isModalOpen) {
            return null;
        }

        return (
            <ConfirmationModal
                cancelMessage="Cancel"
                className="sync-to-lab-modal"
                confirmMessage="Yes, Sync Data"
                message={this.renderOpenCycleModalBody()}
                onCancel={this._cancelOpenCycleModal}
                onClose={this._closeOpenCycleModal}
                onConfirm={this._syncToLabClick}
                title="Ready to send data to Insight Lab?"
            />
        );
    }

    renderOpenCycleModalBody(): React.ReactNode {
        return (
            <div className="sync-to-lab-modal__body">
                <p>Syncing your data will:</p>
                <ul>
                    <li>
                        <i className="icon-check" />
                        Lock all decisions for all users
                    </li>
                    <li>
                        <i className="icon-check" />
                        Sync and update employee pay in Insight Lab
                    </li>
                    <li>
                        <i className="icon-check" />
                        Update current pay in Team with managers&apos; decisions
                    </li>
                    <li>
                        <i className="icon-check" />
                        Cannot be cancelled
                    </li>
                </ul>
            </div>
        );
    }

    private _closeOpenCycleModal(): void {
        this.props.closeModal();
    }

    private _cancelOpenCycleModal(): void {
        this._closeOpenCycleModal();
    }

    private _syncToLabClick(): void {
        this._closeOpenCycleModal();
        this.props.onSyncToLabClick();
    }
}

export default SyncToLabConfirmationModal;